<template>
  <div class="referrals-settings-tab">
    <div class="tab-header">
      <h2>🎁 Configuración de Referidos</h2>
      <p class="description">Gestiona la disponibilidad del programa de referidos</p>
    </div>

    <div class="settings-content">
      <div v-if="loading" class="loading-state">
        <div class="spinner"></div>
        <p>Cargando configuración...</p>
      </div>

      <div v-else class="setting-card">
        <div class="setting-header">
          <div class="setting-info">
            <h3>Habilitar Programa de Referidos</h3>
            <p>Cuando está desactivado, el botón de "Referidos" desaparecerá del menú para todos los usuarios, aunque tengan rol activo. Los usuarios con enlace directo tampoco podrán acceder si se implementa la restricción en el router (opcional).</p>
          </div>
          <div class="toggle-switch">
             <label class="switch">
              <input type="checkbox" v-model="referralsEnabled" @change="toggleReferrals">
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="status-badge" :class="referralsEnabled ? 'active' : 'inactive'">
          {{ referralsEnabled ? 'ACTIVO' : 'INACTIVO' }}
        </div>
      </div>

      <div v-if="message" :class="['message-box', messageType]">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ReferralsSettingsTab',
  data() {
    return {
      loading: true,
      referralsEnabled: false,
      message: '',
      messageType: ''
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      this.loading = true;
      try {
        const response = await axios.get(`${process.env.VUE_APP_API}/api/v1/referrals/settings`);
        if (response.data.status === 'success') {
          this.referralsEnabled = response.data.enabled;
        }
      } catch (error) {
        console.error('Error loading referral settings:', error);
        this.showMessage('Error al cargar la configuración', 'error');
      } finally {
        this.loading = false;
      }
    },
    async toggleReferrals() {
      try {
        const response = await axios.post(`${process.env.VUE_APP_API}/api/v1/referrals/settings`, {
          enabled: this.referralsEnabled
        });
        
        if (response.data.status === 'success') {
          this.showMessage(
            `Programa de referidos ${this.referralsEnabled ? 'activado' : 'desactivado'} correctamente`, 
            'success'
          );
        } else {
          // Revert change on error
          this.referralsEnabled = !this.referralsEnabled;
          this.showMessage('Error al guardar la configuración', 'error');
        }
      } catch (error) {
        // Revert change on error
        this.referralsEnabled = !this.referralsEnabled;
        console.error('Error saving referral settings:', error);
        this.showMessage('Error de conexión al guardar', 'error');
      }
    },
    showMessage(msg, type) {
      this.message = msg;
      this.messageType = type;
      if (type === 'success') {
        setTimeout(() => {
          this.message = '';
        }, 3000);
      }
    }
  }
};
</script>

<style scoped>
.referrals-settings-tab {
  padding: 20px;
}

.tab-header h2 {
  color: #3498db;
  font-size: 24px;
  margin-bottom: 10px;
}

.description {
  color: #bbb;
  margin-bottom: 30px;
}

.setting-card {
  background: #2c2c2c;
  border-radius: 8px;
  padding: 24px;
  border: 1px solid #444;
}

.setting-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.setting-info h3 {
  color: #fff;
  margin: 0 0 8px 0;
  font-size: 18px;
}

.setting-info p {
  color: #aaa;
  margin: 0;
  font-size: 14px;
  max-width: 600px;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
}

.status-badge.active {
  background: rgba(46, 204, 113, 0.2);
  color: #2ecc71;
}

.status-badge.inactive {
  background: rgba(231, 76, 60, 0.2);
  color: #e74c3c;
}

/* Switch Styles */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #3498db;
}

input:focus + .slider {
  box-shadow: 0 0 1px #3498db;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.loading-state {
  text-align: center;
  padding: 40px;
  color: #bbb;
}

.spinner {
  border: 3px solid #333;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.message-box {
  background-color: #333;
  border-radius: 4px;
  margin-top: 15px;
  padding: 10px;
  border-left: 3px solid #3498db;
  color: #fff;
}

.message-box.success {
  border-left-color: #2ecc71;
  color: #2ecc71;
}

.message-box.error {
  border-left-color: #e74c3c;
  color: #e74c3c;
}
</style>
